// Copyright ©️ 2026 eVolve MEP, LLC

import { Box, Flex, Text } from '@mantine/core';

import 'components/Autodesk/forge-viewer.css';
import { ForgeViewerFromModel } from 'components/Autodesk/ForgeViewerFromModel';
import { AutodeskExtensionStoreProvider } from 'components/Autodesk/useAutodeskExtensionStore';
import { ProjectRequired } from 'components/Mantine/GlobalFilters/ProjectRequired';
import { isNotNil } from 'helpers/isNotNil';
import { ModelBrowserProvider } from 'modules/Shop/ModelBrowser/ModelBrowserProvider';

export const ModelBrowserPage = () => (
  <ProjectRequired title="Model Browser">
    <ModelBrowserProvider title="Model Browser">
      {(selectedUrn) => (
        <Box pos="relative" flex={1} className="forge-container">
          {isNotNil(selectedUrn) ? (
            <AutodeskExtensionStoreProvider storeName="apsViewer">
              <AutodeskExtensionStoreProvider storeName="spools">
                <ForgeViewerFromModel urn={selectedUrn} shouldInitializeAuth />
              </AutodeskExtensionStoreProvider>
            </AutodeskExtensionStoreProvider>
          ) : (
            <Flex c="dimmed" h="100%" justify="center" align="center">
              <Text>Select a model to view it here.</Text>
            </Flex>
          )}
        </Box>
      )}
    </ModelBrowserProvider>
  </ProjectRequired>
);
